const CANCELATION_BASE_API_URL =
  'https://api.promova.com';
const GET_IP_API_URL = 'https://pro.ip-api.com/json?key=LOdoXe4dHEKnm9e'

const form = document.querySelector('#form');
const emailInput = document.querySelector('#email');
const textArea = document.querySelector('#text');
const agreementInput = document.querySelector('#agreement');
const tickedCreated = document.querySelector("#ticket_created");
const restartBtn = document.querySelector("#restart");
const mainPart = document.querySelector("#main_part");
const loader = document.querySelector('#loader');
const submitButton = document.querySelector('#submit');
const errorContainer = document.querySelector('#error_message');
const emailPlaceholder = document.querySelector('#user_email')
const footer = document.querySelector('#footer')

const inputs = [emailInput, textArea, agreementInput];

let loading = false;

export const EU_COUNTRIES = [
  'AT', // Austria
  'BE', // Belgium
  'BG', // Bulgaria
  'HR', // Croatia
  'CY', // Cyprus
  'CZ', // Czech Republic
  'DK', // Denmark
  'EE', // Estonia
  'FI', // Finland
  'FR', // France
  'DE', // Germany
  'GR', // Greece
  'HU', // Hungary
  'IE', // Ireland
  'IT', // Italy
  'LV', // Latvia
  'LT', // Lithuania
  'LU', // Luxembourg
  'MT', // Malta
  'NL', // Netherlands
  'PL', // Poland
  'PT', // Portugal
  'RO', // Romania
  'SK', // Slovakia
  'SI', // Slovenia
  'ES', // Spain
  'SE', // Sweden
]

const getCountry = async (callback) => {
  await fetch(GET_IP_API_URL)
  .then((res) => {
    if (!res.ok) {
      return null
    }
    return res.json()
  })
  .then((data) => {
    if (data.status === 'success') {
      const { country, countryCode, regionName, timezone } = data
      callback({ country, countryCode, regionName, timezone })

      return data
    }
  })
}

const changeFooterText = ({countryCode}) => {
  if(countryCode === 'US') {
    footer.innerHTML = 'Promova Limited, 500 North Rainbow Blvd, Suite300, Las Vegas, Nevada, 89107'
  }
  if(countryCode === 'UA') {
    footer.innerHTML = 'TOV “GROWTHSPACE”, Mezhova 23 str., 04123, Kyiv, Ukraine'
  }

  if (EU_COUNTRIES.includes(countryCode)) {
    footer.innerHTML = 'Unlimited Promova Limited, Office 202, 2nd Floor, 15 Nafpliou Str., 3025, Limassol, Cyprus'
  }
}

getCountry(changeFooterText)


const getInputValues = () => {
  const email = emailInput.value;
  const text = textArea.value;
  const agreement = agreementInput.checked;

  return {
    email, text, agreement
  }
}
const startLoading = () => {
  loading = true;
  loader.classList.add('visible');
  loader.classList.remove('hidden');
}

const finishLoading = () => {
  loading = false;
  loader.classList.add('hidden');
  loader.classList.remove('visible');
}

function validateInputs () {
  const {
    text, agreement
  } = getInputValues();

  submitButton.disabled =
  text.length < 10 ||
  !text ||
  !agreement ||
  loading;
}

const setErrorMessage = (message) => {
  errorContainer.textContent = message
}

inputs.forEach((input) => {
  input.addEventListener('input', validateInputs);
});

const handleCreated = () => {
  tickedCreated.classList.add('visible');
  tickedCreated.classList.remove('hidden');
  mainPart.classList.add('hidden');
  mainPart.classList.remove('visible');
  emailPlaceholder.textContent = getInputValues()?.email
  footer.classList.add('hidden')
}

const restartForm = () => {
  tickedCreated.classList.add('hidden');
  tickedCreated.classList.remove('visible');
  mainPart.classList.add('visible');
  mainPart.classList.remove('hidden');
  footer.classList.remove('hidden')
}

restartBtn.addEventListener('click', restartForm);

const createTicketWithUserAppeal = async (config)=> {
  const { email, text } = config;

  startLoading()
  return fetch(`${CANCELATION_BASE_API_URL}/v1/ticket/contact_us`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      email,
      text,
      project: 'Promova',
      topic: '',
      name: 'Student',
    }),
  }).finally(finishLoading);
};

const handleSumbit = async (e) => {
  e.preventDefault();

  const {
    email, text,
  } = getInputValues();

  setErrorMessage('');

  const res = await createTicketWithUserAppeal({ email, text });

  if (res.ok) {
    handleCreated();
  } else {
    setErrorMessage(res.message || 'Somethimg went wrong');
  }
}

form.addEventListener('submit', handleSumbit)
